// extracted by mini-css-extract-plugin
export var alertIcon = "_nn-0";